import Quill from 'quill';

const BlockEmbed: any = Quill.import('blots/block/embed');

/**
 * Custom Quill embed blot that stores a sanitized, CSS-inlined HTML snippet
 * as a single opaque unit. Quill treats it like an image/video embed instead
 * of trying to parse/reformat its contents, so the markup (including inline
 * styles) survives WYSIWYG <-> HTML-source round trips and paste/clipboard
 * conversion untouched.
 *
 * The raw HTML is stored twice:
 * - as the rendered children of the wrapper div (what gets shown/saved)
 * - as a URI-encoded `data-html-embed` attribute (used to restore the exact
 *   original value when Quill re-parses the saved HTML, e.g. on article reload)
 */
export class HtmlEmbedBlot extends BlockEmbed {
  static blotName = 'html-embed';
  static tagName = 'div';
  static className = 'ql-html-embed';

  static create(value: string): HTMLElement {
    const node: HTMLElement = super.create();
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('data-html-embed', encodeURIComponent(value ?? ''));
    node.innerHTML = value ?? '';
    return node;
  }

  static value(node: HTMLElement): string {
    const encoded = node.getAttribute('data-html-embed');
    if (encoded) {
      try {
        return decodeURIComponent(encoded);
      } catch {
        // fall through to innerHTML fallback below
      }
    }
    return node.innerHTML;
  }
}

Quill.register(HtmlEmbedBlot, true);
